import React, { useState, useEffect } from 'react';
import '../../styles/SideBar.css';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../authentication/AuthContext';

const DashboardSidebar = ({ onMenuItemClick }) => {
  const [activeLink, setActiveLink] = useState('dashboard');
  const [activeItem, setActiveItem] = useState('dashboard');
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleMenuItemClick = (menuItem) => {
    setActiveItem(menuItem);
    onMenuItemClick(menuItem);
    setActiveLink(menuItem);
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const { logout, role } = useAuth();
  const location = useLocation();

  const toggleSidebar = () => {
    const sidebarCollapsed = document.getElementsByClassName('sidebar-collapsed');


    for (let element of sidebarCollapsed) {
      if (element.style.display == 'flex') {
        element.style.display = 'none';
        document.getElementById('open-sidebar').style.display = 'block'
        setIsCollapsed(false)
      } else {
        element.style.display = 'flex';
        document.getElementById('open-sidebar').style.display = 'none'
        setIsCollapsed(true)
      }
    }
  };
  useEffect(() => {
    if (!isCollapsed) {
      toggleSidebar();
    }

  }, [location]);

  return (
    <>

          {/* Mobile Sidebar Toggle Button */}
          <button className="mobile-sidebar-toggle" onClick={toggleSidebar}>
      </button>

      <div className={`dashboard-sidebar`} id='open-sidebar'>


        <div className="sidebar-header">

          <div className="user-info">
            <img src="/FBS_circle_logo.png" alt="User Logo" className="user-logo" />
            <div className="username">
              <p>FBS</p>
              <span>{role === 1 ? "Counsellor" : "Super Admin"}</span>
            </div>

          </div>
          <div>
            <button className="logo-name__button" onClick={toggleSidebar}>
              <i
                className={`bx bx-arrow-from-right logo-name__icon`}
                id="logo-name__icon"
              ></i>
            </button>
          </div>
        </div>



        <div className="sidebar-links">
          <ul>
            <Link to='/dashboard'>
              <li
                className={`sidebar-link ${activeLink === 'dashboard' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('dashboard')}
              >
                <i className='bx bxs-dashboard'></i> Dashboard
              </li></Link>

            {role !== 1 && (
              <li
                className={`sidebar-link ${activeLink === 'settings' ? 'active' : ''}`}
                onClick={handleDropdownToggle} style={{ marginTop: '10px' }}
              >
                <i className='bx bxs-cog'></i> Web Settings
                <i className={`bx ${isDropdownOpen ? 'bx-chevron-up' : 'bx-chevron-down'} dropdown-icon`}></i>
              </li>
            )}

            {isDropdownOpen && (
              <ul className="dropdown-menu">
                <Link to='/dashboard/testimonials'>
                  <li
                    className={`dropdown-item ${activeLink === 'testimonials' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('testimonials')}
                  >
                    Testimonials
                  </li>
                </Link>
                <Link to='/dashboard/placed-students'>
                  <li
                    className={`dropdown-item ${activeLink === 'placed-students' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('placed-students')}
                  >
                    Placed Students
                  </li>
                </Link>
                <Link to='/dashboard/aluminis'>
                  <li
                    className={`dropdown-item ${activeLink === 'aluminis' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('aluminis')}
                  >
                    Alumini Speak
                  </li>
                </Link>
                <Link to='/dashboard/fees-structure'>
                  <li
                    className={`dropdown-item ${activeLink === 'fees-structure' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('fees-structure')}
                  >
                    Fees Structure
                  </li>
                </Link>
                <Link to='/dashboard/add-package'>
                  <li
                    className={`dropdown-item ${activeLink === 'add-package' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('add-package')}
                  >
                    Add Package
                  </li>
                </Link>
                <Link to='/dashboard/gallery'>
                  <li
                    className={`dropdown-item ${activeLink === 'gallery' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('gallery')}
                  >
                    Add All Images
                  </li>
                </Link>
                <Link to='/dashboard/recognitions'>
                  <li
                    className={`dropdown-item ${activeLink === 'recognitions' ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick('recognitions')}
                  >
                    Recognitions and Approvals
                  </li>
                </Link>
              </ul>
            )}



            <Link to='/dashboard/enquiry'><li
              className={`sidebar-link ${activeLink === 'enquiry' ? 'active' : ''}`}
              onClick={() => handleMenuItemClick('enquiry')}>
              <i class='bx bxs-conversation'></i>  Enquiries
            </li>
            </Link>
            <Link to='/dashboard/registerStudents'>
              <li
                className={`sidebar-link ${activeLink === 'registerStudents' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('registerStudents')}
              >
                <i class='bx bxs-edit-alt'></i>Registered Students
              </li></Link>
            <Link to='/dashboard/test-result'>
              <li
                className={`sidebar-link ${activeLink === 'test-result' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('test-result')}
              >
                <i class='bx bxs-message-rounded-error'></i> Test Results
              </li>
              </Link>
            <Link to='/dashboard/enroled'>
              <li
                className={`sidebar-link ${activeLink === 'enroled' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('enroled')}>
                <i class='bx bxs-user-check'></i>
                Enrolled Students
              </li>
              </Link>
            
            <Link to='/dashboard/mbaBatch'>
              <li
                className={`sidebar-link ${activeLink === 'mbaBatch' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('mbaBatch')}>
                <i class='bx bxs-user-pin'></i>
                MBA Students List
              </li>
              </Link>

            {role === 1 ? "" :
              <Link to='/dashboard/announcements'>
                <li
                  className={`sidebar-link ${activeLink === 'announcements' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('announcements')}
                >
                  <i className='bx bxs-bell'></i> Announcements
                </li>
              </Link>
            }

            {role === 1 ? "" :
              <Link to='/dashboard/question'>
                <li
                  className={`sidebar-link ${activeLink === 'question' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('question')}
                >
                  <i class='bx bx-math'></i> Question
                </li>
              </Link>
            }


            {role === 1 ?
              <Link to='/dashboard/tasks'>
                <li
                  className={`sidebar-link ${activeLink === 'tasks' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('tasks')}
                >
                  <i class='bx bx-task'></i> Manage Tasks
                </li>
              </Link>
              :
              <Link to='/dashboard/counsellors'>
                <li
                  className={`sidebar-link ${activeLink === 'counsellors' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('counsellors')}
                >
                  <i class='bx bxs-user-detail'></i> Manage counsellors
                </li>
              </Link>
            }


            <li
              className={`sidebar-link ${activeLink === 'logout' ? 'active' : ''}`}
              onClick={logout}
            >
              <i class='bx bx-log-out-circle'></i> Logout
            </li>
          </ul>
        </div>
      </div>

      {/* Small Compressed Sidebar */}
      <div className={`dashboard-sidebar sidebar-collapsed`}>
        <div className="sidebar-header sidebar-collapsed-header">
          <button className="logo-name__button" onClick={toggleSidebar}>
            <i
              className={`bx bx-arrow-from-left logo-name__icon`}
              id="logo-name__icon"
            ></i>
          </button>
          <div className="user-info">
            <img src="/FBS_circle_logo.png" alt="User Logo" className="user-logo" />

          </div>
        </div>



        <div className="sidebar-links">
          <ul>
            <Link to='/dashboard'>
              <li
                className={`sidebar-link ${activeLink === 'dashboard' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('dashboard')}
              >
                <i className='bx bxs-dashboard'></i>
              </li>
            </Link>
            <li
              className={`sidebar-link ${activeLink === 'settings' ? 'active' : ''}`}
              onClick={toggleSidebar} // Toggle dropdown
            >
              <i className='bx bxs-cog'></i>

            </li>

            <Link to='/dashboard/enquiry'>
              <li
                className={`sidebar-link ${activeLink === 'enquiry' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('enquiry')}
              >
                <i class='bx bxs-conversation'></i>
              </li>
            </Link>

            <Link to='/dashboard/registerStudents'>
              <li
                className={`sidebar-link ${activeLink === 'registerStudents' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('registerStudents')}
              >
                <i class='bx bxs-edit-alt'></i>
              </li>
            </Link>
            <Link to='/dashboard/test-result'>
              <li
                className={`sidebar-link ${activeLink === 'test-result' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('test-result')}
              >
                <i class='bx bxs-message-rounded-error'></i>
              </li></Link>

            <Link to='/dashboard/enroled'>
              <li
                className={`sidebar-link ${activeLink === 'enroled' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('enroled')}
              >
                <i class='bx bxs-user-check'></i>

              </li></Link>

              <Link to='/dashboard/mbaBatch'>
              <li
                className={`sidebar-link ${activeLink === 'mbaBatch' ? 'active' : ''}`}
                onClick={() => handleMenuItemClick('mbaBatch')}
              >
                <i class='bx bxs-user-pin'></i>

              </li></Link>


            {role === 1 ? "" :
              <Link to='/dashboard/announcements'>
                <li
                  className={`sidebar-link ${activeLink === 'announcements' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('announcements')}
                >
                  <i className='bx bxs-bell'></i>
                </li>
              </Link>
            }

            {role === 1 ? "" :
              <Link to='/dashboard/question'>
                <li
                  className={`sidebar-link ${activeLink === 'question' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('question')}
                >
                  <i class='bx bx-math'></i>
                </li>
              </Link>
            }


            {role === 1 ?
              <Link to='/dashboard/tasks'>
                <li
                  className={`sidebar-link ${activeLink === 'tasks' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('tasks')}
                >
                  <i class='bx bx-task'></i>
                </li>
              </Link>
              :
              <Link to='/dashboard/counsellors'>
                <li
                  className={`sidebar-link ${activeLink === 'counsellors' ? 'active' : ''}`}
                  onClick={() => handleMenuItemClick('counsellors')}
                >
                  <i class='bx bxs-user-detail'></i>
                </li>
              </Link>
            }
            <li
              className={`sidebar-link ${activeLink === 'logout' ? 'active' : ''}`}
              onClick={logout}
            >
              <i class='bx bx-log-out-circle'></i>
            </li>
          </ul>
        </div>
      </div>


    </>

  );
};

export default DashboardSidebar;
